<template>

  <b-sidebar
    id="sidebar-create-region"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ region.id ? $t('Update Region') : 'Create Region' }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <!-- Uz Name -->
        <b-form-group
          :label="$t('name uz')"
          label-for="uz-name"
        >
          <b-form-input
            id="uz-name"
            v-model="region.name.uz"
            trim
          />
        </b-form-group>

        <!-- Ru Name -->
        <b-form-group
          :label="$t('name ru')"
          label-for="ru-name"
        >
          <b-form-input
            id="ru-name"
            v-model="region.name.ru"
            trim
          />
        </b-form-group>

        <!-- En Name -->
        <b-form-group
          :label="$t('name en')"
          label-for="en-name"
        >
          <b-form-input
            id="en-name"
            v-model="region.name.en"
            trim
          />
        </b-form-group>

        <!-- Country Id -->

        <b-form-group
          :label="$t('Country')"
          label-for="country"
        >
          <v-select
            id="country"
            v-model="region.country"
            :reduce="(option) => option.id"
            :options="countries"
            :get-option-label="(option) => option.name[$i18n.locale]"
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ region.id ? $t('Update Region') : $t('Create Region') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
    countries: {
      get() {
        return this.$store.state.country.countries
      },
    },
    region: {
      get() {
        return this.$store.state.region.region
      },
      set(data) {
        this.$store.commit('region/UPDATE', data)
      },
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit('region/FRESH')
      hide()
    },
    submit(hide) {
      this.$createSwal(this, this.region, `region/${this.region.id ? 'update' : 'create'}`, () => {
        this.$emit('refetchData')
        this.$store.commit('region/FRESH')
      })
      hide()
    },
  },
}
</script>
